module.exports = __webpack_public_path__ + "img/360-degrees.0ba49a4e.svg";